<template>
  <mdb-container fluid class="wrapper3 text-center">
    <mdb-row class=" footrow d-none d-sm-block">
      <mdb-col class="footcol">
        <dontmiss />
      </mdb-col>
    </mdb-row>
    <mdb-row class="mbdontmiss d-sm-none">
      <mbdontmiss />
    </mdb-row>
    <mdb-row class="footrow">
      <mdb-col class="footcol">
        <mdb-footer color="stylish-color-dark" class="page-footer font-small pt-4 mt-4">
          <mdb-container class="text-center">
            <mdb-row>
              <mdb-col md="12">
                <img class="img-fluid center" src="/static/images/logo/newlogo.png" alt="" />
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col md="12">
                <h5 class="text-uppercase mb-4 mt-3 font-weight-bold">car-credit.co.kr</h5>
                <p>수입차 제로금리 리스 전문기업 국산차 렌트/리스 별도문의</p>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <hr class="clearfix w-100 d-md-none" />
              <mdb-col md="12">
                <h5 class="text-uppercase mb-4 mt-3 font-weight-bold">위카</h5>
                <ul class="list-unstyled">
                  <li><a href="#!">대표: 위건우</a></li>
                  <li><a href="#!">T 02-566-3425</a></li>
                  <li><a href="#!">E wecar88@naver.com</a></li>
                  <li><a href="#!">경기도 초원로 10 2층</a></li>
                </ul>
              </mdb-col>
              <hr class="clearfix w-100 d-md-none" />
            </mdb-row>
          </mdb-container>
          <hr />
          <mdb-container>
            <mdb-row>
              <mdb-col md="12">
                <h5 class="mb-1">위카는 최저금리로 진행됩니다.</h5>
              </mdb-col>
              <mdb-col md="12">
                <a class="phone" href="tel:02-566-3425">
                  <mdb-btn class="phoneno btn-lg">
                    <img src="/static/images/icons/phone-call.png"/>
                    무료상담 02-566-3425
                  </mdb-btn>
                </a>
              </mdb-col>
            </mdb-row>
          </mdb-container>
          <mdb-container>
            <mdb-row>
              <mdb-col md="12">
                <privatePolicy />
              </mdb-col>
            </mdb-row>
          </mdb-container>
          <hr />
          <div class="text-center">
            <ul class="list-unstyled list-inline">
              <li class="list-inline-item">
                <a class="btn-floating btn-sm btn-fb mx-1">
                  <i class="fab fa-facebook" />
                </a>
              </li>
              <li class="list-inline-item">
                <a class="btn-floating btn-sm btn-tw mx-1">
                  <i class="fab fa-twitter"/>
                </a>
              </li>
              <li class="list-inline-item">
                <a class="btn-floating btn-sm btn-gplus mx-1">
                  <i class="fab fa-google-plus" />
                </a>
              </li>
              <li class="list-inline-item">
                <a class="btn-floating btn-sm btn-li mx-1">
                  <i class="fab fa-linkedin-in"/>
                </a>
              </li>
              <li class="list-inline-item">
                <a class="btn-floating btn-sm btn-dribbble mx-1">
                  <i class="fab fa-dribbble" />
                </a>
              </li>
            </ul>
          </div>
          <div class="footer-copyright text-center py-3">
            <mdb-container fluid>
              <a> 사업자 등록번호 : 625-25-01081 </a>
            </mdb-container>
            <mdb-container fluid>
              &copy; 2019 start <a href="https://www.car-credit.co.kr"> car-credit.co.kr </a>
            </mdb-container>
          </div>
        </mdb-footer>
      </mdb-col>
    </mdb-row>
    <!--</mdb-container>-->
    <!-- Footer -->
  </mdb-container>
</template>

<script>
import dontmiss from '@/components/DontMiss.vue';
import mbdontmiss from '@/components/mobile/MbDontMiss.vue';
import privatePolicy from '@/components/PrivatePolicy.vue';

export default {
  name: 'FooterPage',
  components: {
    dontmiss,
    mbdontmiss,
    privatePolicy,
  },
};
</script>

<style scoped>
.btn-default {
    color: #fff;
    background-color: black !important;
}

.w-100 {
  max-width: 100% !important;
}

.footimg {
  margin: 0 0px;
  padding: 0 0px;
  align-items: center;
  max-width: 100%;
  max-height: 327px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
  max-width: 100%;
}

@media (max-width: 500px){
  .row {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
    max-width: 100%;
    height: auto;
  }
}

.imgrow
{
  margin: 0 0px;
  padding: 0 0px;
  align-items: center;
  max-width: 100%;
  max-height: 327px;
}

.stylish-color-dark {
  background-color: black !important;
}

.wrapper3 {
  background-color:black;
  max-width: 100%;
  max-height: 100%;
  margin: 0px 0px;
  padding: 0px 0px;
  align-items: center;
}

@media (max-width: 500px){
  .wrapper3 {
    background-color:black;
    max-width: 100%;
    height: auto;
    margin: 0px 0px;
    padding: 0px 0px;
    align-items: center;
  }
}

.imgcol{
  margin: 0 0px;
  padding: 0 0px;
  align-items: center;
  max-width: 100%;
  max-height: 327px;
}

.footrow{
  max-width: 100%;
  align-items: center;
  padding: 0 0px;
  margin: 0 0px;
}

.footcol{
  max-width: 100%;
  align-items: center;
  padding: 0 0px;
  margin: 0 0px;
}

.mt-4, .my-4 {
    margin-top: 0PX !important;
}

.phone img{
  max-width: 30px;
  max-height: 25px;
  margin: auto auto;
  margin-right: 10px;
}

.phoneno{
  background-color:white;
  color:white;
  font-size: 14px;
  max-width: 300px;
}

.phone :active{
  background-color: transparent;
}
</style>
